import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { WorkplaceAddDialogComponent } from '@qaroni-shared/components/dialogs/workplace-add-dialog/workplace-add-dialog.component';
import { WorkplaceService } from '@qaroni-app/workplace/services/workplace.service';
import { Workplace } from '@qaroni-app/workplace/types/workplace';
import { WorkplaceAddDialogData } from '@qaroni-app/workplace/types/workplace-add-dialog-data';
import { WorkplaceStatusEnum } from '@qaroni-app/workplace/types/workplace-status.enum';
import { QaroniDialogConfig } from '@qaroni-core/types/dialogs/qaroni-dialog-config';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Component({
  selector: 'qaroni-workplaces-widget',
  templateUrl: './workplaces-widget.component.html',
  styleUrls: ['./workplaces-widget.component.scss'],
  animations: [qaroniAnimations.enterFadeIn()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkplacesWidgetComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private workplaceService = inject(WorkplaceService);
  private dialog = inject(MatDialog);

  public workplaces = signal<Workplace[]>([]);
  public workplaces$ = this.workplaceService.list$();

  private companyID: number;

  private paramMap$: Observable<ParamMap> = this.route.paramMap.pipe(
    shareReplay(1)
  );

  ngOnInit(): void {
    this.subs.add(this.paramMap$.subscribe(this.getParamMap));
    this.subs.add(this.workplaces$.subscribe(this.getWorkplaces));
  }

  public goToCreateWorkplace() {
    if (Number.isInteger(this.companyID)) {
      const workplaceData: WorkplaceAddDialogData = {
        companyID: this.companyID,
      };
      const dialogConfig = new QaroniDialogConfig<WorkplaceAddDialogData>();
      dialogConfig.data = workplaceData;
      dialogConfig.panelClass = 'qaroni-style-full-close-dialog';
      dialogConfig.width = '450px';
      const dialog = this.dialog.open<
        WorkplaceAddDialogComponent,
        WorkplaceAddDialogData,
        boolean
      >(WorkplaceAddDialogComponent, dialogConfig);

      this.subs.add(dialog.afterClosed().subscribe(this.getCreateWorkplace));
    }
  }

  public goToWorkplacesList() {
    if (this.companyID) {
      this.router.navigate([`/companies/${this.companyID}/workplaces`]);
    }
  }

  private getParamMap = (paramMap: ParamMap): void => {
    if (paramMap.has('companyID')) {
      this.companyID = parseInt(paramMap.get('companyID'));
      const params: Params = { status: WorkplaceStatusEnum.ACTIVE };
      this.workplaceService.list(this.companyID, params);
    }
  };

  private getWorkplaces = (workplaces: Workplace[]): void => {
    if (workplaces?.length) {
      this.workplaces.set(workplaces);
    }
  };

  private getCreateWorkplace = (created: boolean): void => {
    if (created) {
      const params: Params = { status: WorkplaceStatusEnum.ACTIVE };
      this.workplaceService.list(this.companyID, params);
    }
  };
}
